import React from 'react';
import './payment-invoice-card.scss';
import { InvoiceCard } from '../../invoice';
import { Invoice } from '@zonofi/zono-money-store';
import { HeaderCard } from '../../components';

interface PaymentInvoiceCardProps {
  paymentInvoice: Invoice[];
}

export const PaymentInvoiceCard: React.FC<PaymentInvoiceCardProps> = ({
  paymentInvoice,
}) => {
  return (
    <div>
      <HeaderCard
        title={'SELECT INVOICES'}
        subtitle={'Linked payment to outstanding invoices'}
      />

      <div className="payment-details-invoice-container">
        {paymentInvoice?.map((invoiceItem) => (
          <InvoiceCard
            key={invoiceItem.id}
            invoiceItem={invoiceItem}
            // isDisable
            showShare={false}
          />
        ))}
      </div>
    </div>
  );
};
